import { render } from "./ClassList.vue?vue&type=template&id=2d70552b&scoped=true&ts=true"
import script from "./ClassList.vue?vue&type=script&lang=ts"
export * from "./ClassList.vue?vue&type=script&lang=ts"

import "./ClassList.vue?vue&type=style&index=0&id=2d70552b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d70552b"]])

export default __exports__